// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6fc86ecf","455":"3e01900c","977":"be832e1a"}[chunkId] + ".chunk.js";
};